<template>
    <span>
        <button class="ssmall _bt-white mgl0" v-if="formse === 'btn'" @click="handleFileUploadClick"><span>첨부파일</span></button>
        <a href="javascript:;"  v-if="formse === 'btn2'" style="float: left;margin-left: -1px;" class="bg" @click="handleFileUploadClick">업로드</a>
        <div class="file-att-wrap"
             v-if="formse === 'dragAndBtn'"
             :style="{ border:dragOverAt?'2px dotted #488bfd':'2px dotted #e0e0e0' }"
             :draggable="false"
             @dragstart="handleDragStart"
             @dragend="handleDragEnd"
             @dragenter.prevent.stop="handleDragEnter"
             @dragover.prevent.stop="handleDragOver"
             @dragleave="handleDragLeave"
             @drop.prevent.stop="handleDrop">
            <div class="file-att-con">
                <button class="f-left btn-file-att" @click="handleFileUploadClick">
                    <span>파일첨부</span>
                </button>
                <div class="f-left entry-txt">
                    여기로 <span class="pc01">파일을 끌어놓거나</span> [파일첨부] <span class="pc01">버튼을 클릭</span>하세요.<br>(파일 첨부는 {{maxcnt}}개까지 가능하며, 최대 {{maxsize}}MB까지 가능합니다.)
                </div>
            </div>
            <div class="file-att-list mgt15">
                <ul>
                    <template v-for="(fileInfo,index) in filelist">
                        <li v-bind:key="'fileInfo'+index"
                            v-if="fileInfo.fileSe !== 'DEL'">
                            <a href="javascript:;" @click="downloadFile(fileInfo)">
                                <div class="img-com" :class="$onbiLib.bindFileIconClass(fileInfo.extsn)">
                                    <span>{{ fileInfo.extsn }}</span>
                                </div>
                                <template v-if="cdnAt != 'Y'">{{ fileInfo.orgNm + ' [ ' + calShowBtye(fileInfo.fileSize) + ' ]' }}</template>
                                <template v-if="cdnAt == 'Y'">{{ fileInfo.oriFileNm + ' [ ' + calShowBtye(fileInfo.fileSize) + ' ]' }}</template>
                            </a>
                            <button @click="handleDeleteFileClick(index)">
                                <div class="img-com __del04">
                                    <span>삭제</span>
                                </div>
                            </button>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
		<div class="file-att-wrap"
             v-if="formse === 'multiBtn'"
             :draggable="false"
             @dragstart="handleDragStart"
             @dragend="handleDragEnd"
             @dragenter.prevent.stop="handleDragEnter"
             @dragover.prevent.stop="handleDragOver"
             @dragleave="handleDragLeave"
             @drop.prevent.stop="handleDrop" style="padding : 7px; border:none;">
            <div class="file-att-con">
                <button class="f-left btn-file-att" @click="handleFileUploadClick">
                    <span>파일첨부</span>
                </button>
				<ul>
                    <template v-for="(fileInfo,index) in filelist">
                        <li v-bind:key="'fileInfo'+index"
                            v-if="fileInfo.fileSe !== 'DEL'">
                            <a href="javascript:;">
                                <div class="img-com" :class="$onbiLib.bindFileIconClass(fileInfo.extsn)">
                                    <span>{{ fileInfo.extsn }}</span>
                                </div>{{ fileInfo.orgNm + ' [ ' + calShowBtye(fileInfo.fileSize) + ' ]' }}
                            </a>
                            <button @click="handleDeleteFileClick(index)">
                                <div class="img-com __del04">
                                    <span>삭제</span>
                                </div>
                            </button>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <input ref="ip_file" type="file" multiple="multiple" v-if="showFileInput('list')" @change="handleUploadFileChange" style="display: none;" :accept="setAcceptList">
        <input ref="ip_file" type="file" v-if="showFileInput('one')" @change="handleUploadFileChange" style="display: none;" :accept="setAcceptList">
    </span>
</template>

<script>
    export default {
        name: "fileupload",
        props: ["formse","filelist","maxcnt","maxsize","extsns","func","delFunc","setfilegrpcd","setstorge","setbasepath","cdnAt","autoDelAt","errMsgPrefix"],
        data: function () {
            return {
                dragOverAt:false,
                basePath:null,
                stroge:null,
                extsnList:new Array(),
                uploadReady:true,
                fileGrpCd:new Array(),
                uploadPercentage: 0,
                uploadLoad:0,
                uploadTotal:0,
            }
        },
        methods: {
            showFileInput : function(se){
                if("list" == se){
                    if(this.uploadReady&&this.maxcnt > 1){
                        return true;
                    }else{
                        return false;
                    }
                }else if("one" == se){
                    if(this.uploadReady&&this.maxcnt == 1){
                        return true;
                    }else{
                        return false;
                    }
                }

                return false;

            },
            downloadFile : function(fileInfo){
                const _this = this;
                if(this.$onbiLib.chkCdnAt(fileInfo)){
                    _this.$onbiLib.getAuthKey().then(function(authKey){
                        _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo,encodeURIComponent(authKey));
                    });
                }else{
                    this.$onbiLib.setFileDownLoadUrl('/common/downloadFile.act', 'fileCd='+fileInfo.fileCd);
                }

                //this.$onbiLib.setFileDownLoadUrl('/common/downloadFile.act', 'fileCd='+fileInfo.fileCd);
            },
            handleFileUploadClick: function(){
                this.$refs.ip_file.click();
            },
            handleUploadFileChange: function(){
                this.uploadFileListSet(this.$refs.ip_file.files);
            },
            handleDragStart: function(){
                console.log('');
            },
            handleDragEnd: function(){
                console.log('');
            },
            handleDragEnter: function(){
                this.dragOverAt = true;
            },
            handleDragOver: function(){
                if(!this.dragOverAt) this.dragOverAt = true;
            },
            handleDragLeave: function(){
                this.dragOverAt = false;
            },
            handleDrop: function(e){
                this.dragOverAt = false;
                var files = e.dataTransfer.files;
                this.uploadFileListSet(files);
            },
            handleDeleteFileClick: function(index){
                var delFileInfo = this.filelist[index];
                if(delFileInfo != null){
                    if(delFileInfo.fileSe == "NEW"){
                        this.filelist.splice(index,1);
                    }else{
                        delFileInfo.fileSe = "DEL";
                    }
                }

                if(typeof this.delFunc != "undefined"){
                    this.delFunc();
                }
            },
            uploadFileListSet: function(files){
                let errMsgPrefix = '';

                if(this.errMsgPrefix != 'undefined'&&this.errMsgPrefix != null){
                    errMsgPrefix = this.errMsgPrefix;
                }

                if(this.stroge != null) {
                    var totSize = 0;
                    var totCnt = 0;

                    if (files.length == 0) {
                        this.$toasted.show("첨부할 " + errMsgPrefix + "파일을 끌어놓아주십시오.");
                        return false;
                    }

                    for (var i = 0; i < files.length; i++) {
                        totSize += files[i].size;

                        var fileNmae = files[i].name;

                        if (fileNmae == this.getExtsn(fileNmae) || this.getExtsn(fileNmae) == "") {
                            this.$toasted.show("확장자가 없는 파일은 첨부가 불가능합니다.");
                            return false;
                        }

                        var chkExtsnInfo = this.chkExtsn(fileNmae);
                        if (chkExtsnInfo.chkAt) {
                            this.$toasted.show("." + chkExtsnInfo.extsn + "파일은 첨부가 불가능합니다.");
                            return false;
                        }
                        totCnt++;
                    }

                    var setFileList = this.filelist;

                    if (this.maxcnt == 1) {
                        if (totSize > this.calBtye(this.maxsize)) {
                            this.$toasted.show(errMsgPrefix + "파일 첨부는 최대 " + this.maxsize + "MB까지 가능합니다.");
                            return false;
                        }

                        for (let i = 0; i < setFileList.length; i++) {
                            var fileInfo = setFileList[i];
                            if (fileInfo.fileSe == "NEW") {
                                setFileList.splice(i, 1);
                            } else {
                                fileInfo.fileSe = "DEL";
                            }
                        }
                    } else {
                        for (let i = 0; i < setFileList.length; i++) {
                            if (setFileList[i].fileSe != "DEL") {
                                totSize += setFileList[i].size;
                                totCnt++;
                            }
                        }


                        if (totCnt > this.maxcnt) {
                            this.$toasted.show(errMsgPrefix + "파일 첨부는 최대 " + this.maxcnt + "개까지 가능합니다.");
                            return false;
                        }

                        if (totSize > this.calBtye(this.maxsize)) {
                            this.$toasted.show(errMsgPrefix + "파일 첨부는 최대 " + this.maxsize + "MB까지 가능합니다.");
                            return false;
                        }
                    }

                    var cdnAt = this.cdnAt;
                    const _this = this;

                    if (this.cdnAt == 'undefined' || this.cdnAt == null) cdnAt = 'N';
                    if (cdnAt == 'N') {
                        var formData = new FormData();
                        for (let i = 0; i < files.length; i++) {
                            formData.append('uploadFile', files[i]);
                        }

                        formData.append('fileGrpCd', this.fileGrpCd);
                        formData.append('storge', this.stroge);
                        formData.append('basePath', this.basePath);

                        this.axios.post(
                            '/common/setAttachFile.act',
                            formData,
                            {
                                headers: {'Content-Type': 'multipart/form-data'},
                                onUploadProgress: function (progressEvent) {
                                    this.uploadLoad = progressEvent.loaded;
                                    this.uploadTotal = progressEvent.total;
                                    this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                                }.bind(this)
                            }
                        ).then(function (response) {
                            _this.uploadLoad = 0;
                            _this.uploadTotal = 0;
                            _this.uploadPercentage = 0;

                            for (var i = 0; i < response.data.fileList.length; i++) {
                                setFileList.push(response.data.fileList[i]);
                            }

                            _this.uploadReady = false;
                            _this.$nextTick(function () {
                                _this.uploadReady = true;
                                if (typeof _this.func != "undefined") {
                                    _this.func();
                                    this.uploadPercentage = 0;
                                }
                            })
                        }).catch(function (e) {
                            console.log(e);
                        });
                    }else if(cdnAt == 'Y') {
                        this.getCdnTransmisSn().then(function(transmisSn){
                            return _this.cdnUploadFile(files, transmisSn);
                        }).then(function(uploadInfo){
                            return _this.saveCdnFileUploadInfo(uploadInfo);
                        }).then(function(){
                            _this.uploadLoad = 0;
                            _this.uploadTotal = 0;
                            _this.uploadPercentage = 0;

                            _this.uploadReady = false;
                            _this.$nextTick(function(){
                                _this.uploadReady = true;
                                if(typeof _this.func != "undefined"){
                                    _this.func();
                                }
                            })
                        }).catch(function(e){
                            console.log(e);
                        });
                    }
                }else{
                    this.$toasted.show("화면 로딩이 완료되지않았습니다.<br/>잠시만 기다려주십시오.");
                }
            },
            getCdnTransmisSn: function(){
                const _this = this;
                return new Promise(function (resolve, reject) {
                    _this.axios.get('/fileApi/getTransmisSn').then(function(response){
                        resolve(response.data.transmisSn);
                    }).catch(function(e){
                        reject(e);
                    });
                });
            },
            cdnUploadFile: function(files,transmisSn){
                var _this = this;
                return new Promise(function (resolve, reject) {
                    var formData = new FormData();

                    for (var i = 0; i < files.length; i++){
                        formData.append('uploadFile[]', files[i]);
                    }

                    formData.append('transmisSn', transmisSn);
                    formData.append('storage'   , _this.stroge);
                    formData.append('basePath'  , _this.basePath);

                    _this.axios.post(
                        _this.$onbiLib.getCdnUrl('U') + '/fileApi/uploadFile',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(function(response){
                        resolve(response.data);
                    }).catch(function(e){
                        reject(e);
                    });
                });
            },
            saveCdnFileUploadInfo: function(uploadInfo){
                const _this = this;
                return new Promise(function (resolve, reject) {
                    var resultCd = uploadInfo.resultCd;
                    var resultMsg = uploadInfo.resultMsg;
                    if(resultCd == '00'){
                        var fileList = uploadInfo.fileList;
                        var setFileList = new Array();
                        for(var i=0;i < fileList.length;i++){
                            var fileInfo = fileList[i];
                            var extsn = fileInfo.extsn;
                            if(extsn == 'jpg'||extsn == 'mp4'){ fileInfo['sucAt'] = 'N';
                            }else{ fileInfo['sucAt'] = 'Y'; }
                            setFileList.push(fileInfo);
                        }
                        _this.axios.post(
                            '/fileApi/saveFileUploadInfo',
                            {
                                transmisSn: uploadInfo.transmisSn,
                                resultCd: uploadInfo.resultCd,
                                resultMsg: uploadInfo.resultMsg,
                                fileList: setFileList
                            }
                        ).then(function(){
                            _this.$onbiLib.getAuthKey().then(function(authKey){
                                const setAuthKey = encodeURIComponent(authKey);
                                for(var i=0; i<setFileList.length; i++ ){
                                    var fileInfo = setFileList[i];
                                    fileInfo['fileSe'] = 'NEW';
                                    fileInfo['cdnAt'] = 'Y';
                                    fileInfo['authKey'] = setAuthKey;
                                    _this.filelist.push(fileInfo);
                                }
                            })

                            resolve();
                        }).catch(function(e){
                            reject(e);
                        });
                    }else{
                        reject(resultMsg);
                    }

                });
            },
            calBtye:function(mb){
                return mb*1048576
            },
            calShowBtye:function(b){
                var calByte = "";

                if(b < 1024){
                    calByte = "1KB";
                }else if(b >= 1024 && b < 1048576){
                    calByte = (b/1024).toFixed(1) + "KB";

                }else if(b >= 1048576){
                    calByte = (b/1048576).toFixed(1) + "MB";
                }

                return calByte;
            },
            getExtsn : function(fileNm){
                return fileNm.substring( fileNm.lastIndexOf(".")+1 );
            },
            chkExtsn : function(fileNm){
                var extsn = this.getExtsn(fileNm);

                for(var i=0; i<this.extsnList.length; i++){
                    if(this.extsnList[i] == extsn.toLowerCase()){
                        return {
                            "chkAt" : false,
                            "extsn" : ""
                        };
                    }
                }
                return {
                    "chkAt" : true,
                    "extsn" : extsn
                };
            },
            bindFileIconClass: function(extsn){
                return this.$onbiLib.bindFileIconClass(extsn);
            }
        },
        mounted:function(){
            var defaultSetAt = true;

            if(typeof this.setbasepath != "undefined" && this.setbasepath != null){
                if(this.setbasepath.trim() != ""){
                    this.basePath = this.setbasepath;
                }
            }

            if(typeof this.setfilegrpcd != "undefined" && this.setfilegrpcd != null){
                this.fileGrpCd = this.setfilegrpcd;
                this.stroge = this.setstorge;
                defaultSetAt = false;
            }else{
                if(typeof this.setstorge != "undefined" && this.setstorge != null){
                    if(this.setstorge.trim() != ""){
                        this.fileGrpCd = "";
                        this.stroge = this.setstorge;
                        defaultSetAt = false;
                    }
                }
            }

            const _this = this;

            if(defaultSetAt){
                if(this.filelist > 0){
                    this.fileGrpCd = this.filelist[0].fileGrpCd;
                    this.stroge = this.filelist[0].stroge;
                }else{
                    this.axios.post('/common/day/searchDayTimeMs.act',{})
                        .then(function(response) {
                            let fcltcd = '';

                            if(typeof this.$store.getters.getAppName !='undefined'){	//모바일 접속한 경우
                                fcltcd = _this.$store.getters.getLoginInfo.fcltInfo.fcltcd;
                            }else {
                                fcltcd = _this.$store.getters.getMberInfo.fcltcd;
                            }
                            _this.fileGrpCd = "";
                            _this.stroge = fcltcd + "/attach/" + response.data.dayTimeMs + "/";
                        }.bind(this)).catch(function(e) {
                        console.log(e);
                        _this.$toasted.show(_this.$onbiLib.msg.err.system);
                    });
                }
            }

            this.extsnList = this.extsns.split(",");
        },
        computed : {
            setAcceptList: function(){
                var setAcceptList = "";

                for(var i=0; i < this.extsnList.length; i++){
                    setAcceptList += "." + this.extsnList[i];

                    if(i < this.extsnList.length - 1){
                        setAcceptList += ",";
                    }
                }

                return setAcceptList;
            }
        }
    }
</script>

<style scoped>

</style>